
interface Case {
  title: string;
  desc: string;
}

interface Business {
  title: string;
  cases: Case[];
}

interface BusinessCasesProps {
  business: Business;
}

export default function BusinessCases({ business }: BusinessCasesProps) {
  const caseIcons = ["ri-building-line", "ri-government-line"];

  return (
    <section id="cases" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-sm font-semibold tracking-widest text-teal-600 uppercase">Success Stories</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3">客户案例</h2>
          <p className="text-base text-gray-500 mt-3 max-w-2xl mx-auto">
            真实的项目成果，见证{business.title}领域的价值交付
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {business.cases.map((item, idx) => (
            <div
              key={idx}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-100 hover:shadow-xl hover:border-teal-100 transition-all duration-300"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-teal-50 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-500 transition-colors">
                  <i className={`${caseIcons[idx % 2]} text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
              <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-full">
                  <i className="ri-arrow-right-up-line text-teal-600"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
